// eslint-disable-next-line import/prefer-default-export
export const NAMESPACE = "ui-components";
export const TIME_FORMAT_DAY_MONTH = "DD.MM";
